import { Fragment, h } from "preact";
import { useState, useEffect } from "preact/hooks";
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
    Typography,
    Stack,
} from "@mui/material";


export default function CancelMandateDialog(props) {
    //console.log("CancelMandateDialog",props);
    const handleClose = () => {
        props.onClose();
    };
    const check_phrase = "résilier le mandat";
    const [state, setState] = useState({
        step: "step1",
    });
    const [disabled, setDisabled] = useState(true);
    useEffect(() => {
        //console.log(state.confirm, state.confirm === "supprimer " + props.state.params.name);
        setDisabled(!(state.confirm === check_phrase));
    }, [state]);
    const handleChange = () => {

    }
    const cancelMandate = () => {
        const requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        };
        fetch("/api/4fd98dd477ee423ab2bb0bf55fc2af1b/" + props.state.params.uid, requestOptions)
            .then((response) => {
                return response.json();
            })
            .then((res) => {
                switch (res.res) {
                    case "ok":

                        window.location.reload();

                        break;
                    case "err":
                        break;
                    default:
                        break;
                }
            });

    }
    return (
        <Dialog onClose={handleClose} aria-labelledby="add-user-dialog" open={props.state.opened} maxWidth="sm" fullWidth={false}>
            <DialogTitle id="add-user-dialog">
                <Typography variant="h5">Résilier le mandat</Typography>
            </DialogTitle>
            <DialogContent dividers>
                <Stack spacing={1}>
                    {state.step == "step1" && (
                        <Typography variant="h5" >Voulez-vous vraiment résilier le mandat ?</Typography>
                    )}
                    {state.step == "step2" && (<Fragment>
                        <Typography variant="body1" gutterBottom>
                            Pour confirmer votre choix, merci d'écrire exactement la phrase suivante: <Typography variant="h5" style={{ textAlign: "center", padding: "10px" }}>{check_phrase}</Typography> en toutes lettres dans le champ ci-dessous
                        </Typography>
                        <TextField
                            id="confirm"
                            name="confirm"
                            variant="outlined"
                            style={{
                                marginLeft: 0,
                                marginRight: 10,
                            }}
                            placeholder={check_phrase}
                            fullWidth
                            margin="dense"
                            size="small"
                            value={state.confirm}
                            onChange={handleChange}
                        />
                    </Fragment>)}
                </Stack>
            </DialogContent>
            <DialogActions>
                <Box display="flex" justifyContent="space-between" alignItems={"center"} style="width: 100%">
                    <Box>
                        <Button onClick={handleClose} variant="outlined">
                            Annuler
                        </Button>
                    </Box>
                    <Box>
                        {state.step == "step1" && <Button onClick={() => { setState({ ...state, step: "step2" }) }} variant="contained">
                            OUI
                        </Button>}
                        {state.step == "step2" && <Button onClick={cancelMandate} variant="contained">
                            RESILIER
                        </Button>}
                    </Box>
                </Box>
            </DialogActions>
        </Dialog >
    );
}
